"use strict";

import UserPurchaseTicket from "./UserPurchaseTicket.jsx";

export const auth = true;
export const title = "i18n:userPurchaseTicket.pageTitle";
export const Component = UserPurchaseTicket;
